import { FC } from 'react';
import clsx from 'clsx';
import { StyledCompareCard } from './CompareCard.styles';
import { Button, Text, tags, size } from '@marriott/mi-ui-library';
import { CobrandImage } from '../../../molecules/CobrandImage/CobrandImage';
import { useStore } from '../../../modules/store/cobrandStore';
import { CompareCardProps } from './CompareCard.types';

const applyTagStyles = (cardtype: string) => (cardtype.toLowerCase() === 'business' ? 'business-badge' : '');

export const CompareCard: FC<CompareCardProps> = ({ index, item, defaultContent, styleClass }) => {
  const { cobrandData, setCobrandData } = useStore(store => store);
  const handleRemove = (id: string) => {
    setCobrandData({
      ...cobrandData,
      selectedCards: cobrandData.selectedCards.filter(({ cardname }) => cardname !== id),
    });
  };
  const shellSubtitle = index === 2 ? 'Select a card (optional)' : 'Select a card (required)';

  return (
    <StyledCompareCard className={styleClass}>
      {defaultContent ? (
        <div className="card-shell d-flex justify-content-center align-items-center flex-column">
          <Text copyText={`Card ${index + 1}`} fontSize={size.small} element={tags.span} customClass="mb-1" />
          <Text copyText={shellSubtitle} fontSize={size.extraSmall} element={tags.span} customClass="shell-subtitle" />
        </div>
      ) : (
        <div className="card-container d-flex flex-md-column align-items-md-center justify-content-center">
          {item?.cardType && (
            <div className={clsx('card-tag d-none d-md-block', applyTagStyles(item.cardType))}>
              <Text copyText={item.cardType} fontSize={size.extraSmall} element={tags.paragraph} />
            </div>
          )}
          {item?.cardname && (
            <Button
              className="icon-clear remove-card"
              callback={() => {
                if (item.cardname) handleRemove(item.cardname);
              }}
            />
          )}
          <CobrandImage defaultImageURL={item?.imagePath} customClass="card-image" />
          <div className="ml-2 ml-md-0">
            {item?.cardType && (
              <div className={clsx('card-sm-tag d-md-none', applyTagStyles(item.cardType))}>
                <Text copyText={item.cardType} fontSize={size.extraSmall} element={tags.paragraph} />
              </div>
            )}
            {item?.header && (
              <Text
                copyText={item.header}
                fontSize={size.extraSmall}
                element={tags.div}
                customClass="mt-2 d-flex text-md-center align-items-center card-header"
              />
            )}
          </div>
        </div>
      )}
    </StyledCompareCard>
  );
};
